/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  GetRpcVehiclesForLocationParams,
  PostgrestError,
  RpcVehiclesForLocationArgs,
  Vehicles
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getRpcVehiclesForLocationResponse200 = {
  data: Vehicles[]
  status: 200
}

export type getRpcVehiclesForLocationResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getRpcVehiclesForLocationResponseSuccess = (getRpcVehiclesForLocationResponse200) & {
  headers: Headers;
};
export type getRpcVehiclesForLocationResponseError = (getRpcVehiclesForLocationResponseDefault) & {
  headers: Headers;
};

export type getRpcVehiclesForLocationResponse = (getRpcVehiclesForLocationResponseSuccess | getRpcVehiclesForLocationResponseError)

export const getGetRpcVehiclesForLocationUrl = (params: GetRpcVehiclesForLocationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/rpc/vehicles_for_location?${stringifiedParams}` : `${backendBaseUrl}/rpc/vehicles_for_location`
}

/**
 * @summary Call `vehicles_for_location()`.
 */
export const getRpcVehiclesForLocation = async (params: GetRpcVehiclesForLocationParams, options?: RequestInit): Promise<getRpcVehiclesForLocationResponse> => {

  const res = await fetch(getGetRpcVehiclesForLocationUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getRpcVehiclesForLocationResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getRpcVehiclesForLocationResponse
}


export type postRpcVehiclesForLocationResponse200 = {
  data: Vehicles[]
  status: 200
}

export type postRpcVehiclesForLocationResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type postRpcVehiclesForLocationResponseSuccess = (postRpcVehiclesForLocationResponse200) & {
  headers: Headers;
};
export type postRpcVehiclesForLocationResponseError = (postRpcVehiclesForLocationResponseDefault) & {
  headers: Headers;
};

export type postRpcVehiclesForLocationResponse = (postRpcVehiclesForLocationResponseSuccess | postRpcVehiclesForLocationResponseError)

export const getPostRpcVehiclesForLocationUrl = () => {




  return `${backendBaseUrl}/rpc/vehicles_for_location`
}

/**
 * @summary Call `vehicles_for_location()`.
 */
export const postRpcVehiclesForLocation = async (rpcVehiclesForLocationArgs: RpcVehiclesForLocationArgs, options?: RequestInit): Promise<postRpcVehiclesForLocationResponse> => {

  const res = await fetch(getPostRpcVehiclesForLocationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rpcVehiclesForLocationArgs)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postRpcVehiclesForLocationResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postRpcVehiclesForLocationResponse
}


